import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { NavigationStacks, Screens, Stacks } from 'components/Navigation/types';
import { NavigationHeader } from 'components/NavigationHeader';
import { Page } from 'components/Page';
import { PageEmpty } from 'components/PageEmpty';
import React from 'react';
import { RepeatableListIntro } from './RepeatableListIntro';

type Props = NativeStackScreenProps<
  NavigationStacks[Stacks.ASEREPEATABLE],
  Screens.ASEREPEATABLE_INTRO
>;

export const RepeatableListIntroScreen: React.FC<Props> = ({ route }) => {
  const { groupId, parent } = route.params;
  return (
    <Page
      isInModal={!!parent}
      contentPaddingTop={0}
      contentPaddingBottom={0}
      header={<NavigationHeader />}
    >
      <PageEmpty style={{ flex: 1, justifyContent: 'center' }}>
        <RepeatableListIntro groupId={groupId} parent={parent} />
      </PageEmpty>
    </Page>
  );
};
